<template>
  <div class="Penggunasistem">
    <v-snackbar
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.message }}
    </v-snackbar>

    <v-card outlined class="mb-4">
      <v-card-title class="py-3 kad__tajuk d-flex align-center flex-wrap">
        <v-icon small class="mr-2">mdi-account-group</v-icon>
        <span class="subtitle-1 font-weight-medium">{{ $t("senaraipengguna") }}</span>
      </v-card-title>
      <v-form ref="formtapisanpengguna">
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="search"
              outlined
              dense
              v-bind:label="$t('cari')"
              class="mx-4"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-col class="text-right pt-0">
              <v-btn class="btn-teal text-none" @click="modaltambahpengguna">
                <v-icon left>mdi-plus</v-icon>
                {{ $t("tambah") }}
              </v-btn>
            </v-col>
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
        :headers="tableHeaders"
        :items="datapengguna"
        :search="search"
        :items-per-page="20"
        class="elevation-1"
        @click:row="modalkemaskinidatapengguna"
      >
        <template v-if="isSuperadmin" v-slot:[`item.tindakan`]="{ item }">
          <v-btn
            small
            depressed
            color="warning"
            class="text-none"
            @click.stop="modalresetkatalaluan(item)"
          >
            <v-icon left small>mdi-lock-reset</v-icon>
            {{ $t("kemaskinikatalaluan") }}
          </v-btn>
        </template>
        <template v-slot:[`item.statuslogmasuk`]="{ item }">
          <span v-bind:class="warnastatuslogmasuk(item.statuslogmasuk)">{{
            item.statuslogmasuk
          }}</span>
        </template>
        <template v-slot:[`item.statusakaun`]="{ item }">
          <span v-bind:class="statusakaun(item.statusakaun)">{{
            item.statusakaun
          }}</span>
        </template>
        <template v-slot:top>
          <v-dialog v-model="dialogtambahpengguna" persistent max-width="500px">
            <v-card>
              <v-form ref="formtambahpengguna">
                <v-card-title class="py-3 kad__tajuk">
                  <v-icon small class="mr-2">mdi-account-plus</v-icon>
                  <span class="subtitle-1 font-weight-medium">{{ $t("tambahpengguna") }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          dense
                          v-model="daftarnama"
                          :rules="[required('nama'), namamin6]"
                          :error-messages="msgnamamin6"
                          v-bind:label="$t('nama')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          dense
                          v-model="daftaremel"
                          :rules="[
                            required('emel'),
                            emelsudahwujud,
                            rules.email,
                          ]"
                          :error-messages="msgkemaskiniemelsudahwujud"
                          v-bind:label="$t('emel')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          :items="lookupnegeri"
                          v-model="daftarnegeri"
                          :rules="[required('negeri')]"
                          outlined
                          dense
                          item-text="negeri"
                          item-value="id"
                          v-bind:label="$t('negeri')"
                          item-disabled="disable"
                          :disabled="disablenegeri"
                          required
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          :items="daftarlookupperanan"
                          v-model="daftaperanan"
                          :rules="[required('peranan')]"
                          item-disabled="disable"
                          outlined
                          dense
                          item-text="peranan"
                          item-value="id"
                          v-bind:label="$t('peranan')"
                          v-on:change="tukarnegerikeadmin"
                          required
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text class="text-none" @click="dialogtambahpengguna = false">
                    {{ $t("tutup") }}
                  </v-btn>
                  <v-btn class="btn-teal text-none" @click="hantartambahpengguna">
                    {{ $t("hantar") }}
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogkemaskinipengguna"
            persistent
            max-width="500px"
          >
            <v-card>
              <v-form ref="formkemaskinimaklumatpengguna">
                <v-card-title class="py-3 kad__tajuk">
                  <v-icon small class="mr-2">mdi-account-edit</v-icon>
                  <span class="subtitle-1 font-weight-medium">{{ $t("kemaskinimaklumatpengguna") }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-text-field v-model="semakkemaskininama" v-show="false">
                      </v-text-field>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          dense
                          v-model="kemaskininama"
                          :rules="[required('nama')]"
                          v-bind:label="$t('nama')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="statussemakkemaskiniemel"
                          v-show="false"
                        >
                        </v-text-field>
                        <v-text-field
                          outlined
                          dense
                          v-model="kemaskiniemel"
                          :rules="[required('emel'), rules.email]"
                          v-bind:label="$t('emel')"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          :items="lookupnegeri"
                          v-model="kemaskininegeri"
                          :rules="[required('negeri')]"
                          outlined
                          dense
                          item-text="negeri"
                          item-value="id"
                          v-bind:label="$t('negeri')"
                          :disabled="disablenegeri"
                          required
                        ></v-select>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          v-bind:label="$t('Status Enable/Disable')"
                          :rules="[required('status')]"
                          :items="['Enable','Disable']"
                          v-model="kemaskinistatus"
                          outlined
                          dense
                          item-text="Status"
                        ></v-select>
                      </v-col>
                      <!-- <v-col
                                    cols="12"
                                > -->
                      <!-- <v-select
                                :items="lookupperanan"
                                v-model="kemaskiniperanan"
                                :rules="[required('peranan')]"
                                outlined dense
                                item-text="peranan"
                                item-value="id"
                                v-bind:label="$t('peranan')"
                                required
                                ></v-select> -->
                      <!-- </v-col> -->

                      <v-col cols="4">
                        <v-checkbox
                          v-model="perananpilihan"
                          label="ADMIN"
                          value="ADMIN"
                          :disabled="disableperananadmin"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="4">
                        <v-checkbox
                          v-model="perananpilihan"
                          label="SUPERADMIN"
                          value="SUPERADMIN"
                          :disabled="disableperananadmin"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="4">
                        <v-checkbox
                          v-model="perananpilihan"
                          label="PP"
                          value="PP"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="4">
                        <v-checkbox
                          v-model="perananpilihan"
                          label="PO"
                          value="PO"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="4">
                        <v-checkbox
                          v-model="perananpilihan"
                          label="FE/DE"
                          value="FE"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text class="text-none" @click="dialogkemaskinipengguna = false">
                    {{ $t("tutup") }}
                  </v-btn>
                  <v-btn class="btn-teal text-none" @click="hantarkemaskinipengguna">
                    {{ $t("hantar") }}
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="dialogresetkatalaluan"
            persistent
            max-width="500px"
          >
            <v-card>
              <v-form ref="formresetkatalaluan">
                <v-card-title class="py-3 kad__tajuk">
                  <v-icon small class="mr-2">mdi-lock-reset</v-icon>
                  <span class="subtitle-1 font-weight-medium">{{ $t("kemaskinikatalaluan") }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-alert dense text type="info" class="mb-4 text-caption" border="left">
                      <div class="font-weight-medium mb-1">
                        Standard Kata Laluan Minimum - {{ resetnamapengguna }}
                      </div>
                      <div class="mb-1">
                        <v-icon x-small :color="petunjukPanjang ? 'success' : 'grey'">
                          {{ petunjukPanjang ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                        </v-icon>
                        Panjang minimum {{ MIN_PANJANG_KATALALUAN }} aksara
                      </div>
                      <div>
                        <v-icon x-small :color="bilanganJenisKarakter >= 3 ? 'success' : 'grey'">
                          {{ bilanganJenisKarakter >= 3 ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                        </v-icon>
                        Sekurang-kurangnya 3 daripada 4 jenis berikut ({{ bilanganJenisKarakter }}/4):
                      </div>
                      <div class="pl-6">
                        <span :class="petunjukHurufBesar ? 'success--text' : 'grey--text'">
                          <v-icon x-small :color="petunjukHurufBesar ? 'success' : 'grey'">
                            {{ petunjukHurufBesar ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                          Huruf besar (A-Z)
                        </span>
                        <br>
                        <span :class="petunjukHurufKecil ? 'success--text' : 'grey--text'">
                          <v-icon x-small :color="petunjukHurufKecil ? 'success' : 'grey'">
                            {{ petunjukHurufKecil ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                          Huruf kecil (a-z)
                        </span>
                        <br>
                        <span :class="petunjukNombor ? 'success--text' : 'grey--text'">
                          <v-icon x-small :color="petunjukNombor ? 'success' : 'grey'">
                            {{ petunjukNombor ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                          Nombor (0-9)
                        </span>
                        <br>
                        <span :class="petunjukSimbol ? 'success--text' : 'grey--text'">
                          <v-icon x-small :color="petunjukSimbol ? 'success' : 'grey'">
                            {{ petunjukSimbol ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                          Simbol khas (!@#$%^&amp;*)
                        </span>
                      </div>
                    </v-alert>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          dense
                          v-model="resetkatalaluanbaru"
                          v-bind:label="$t('katalaluanbaru')"
                          :rules="[required('katalaluanbaru'), kekuatankatalaluan]"
                          :type="paparresetbaru ? 'text' : 'password'"
                          :append-icon="paparresetbaru ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="paparresetbaru = !paparresetbaru"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          outlined
                          dense
                          v-model="resetmasukkatalaluanbaru"
                          v-bind:label="$t('masuksemulakatalaluanbaru')"
                          :rules="[required('masuksemulakatalaluanbaru'), katalaluanbarusama(resetkatalaluanbaru, resetmasukkatalaluanbaru)]"
                          :type="paparresetsemulabaru ? 'text' : 'password'"
                          :append-icon="paparresetsemulabaru ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="paparresetsemulabaru = !paparresetsemulabaru"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions class="px-6 pb-4">
                  <v-spacer></v-spacer>
                  <v-btn color="grey darken-1" text @click="dialogresetkatalaluan = false">
                    {{ $t("tutup") }}
                  </v-btn>
                  <v-btn color="success" depressed :disabled="!bolehResetKatalaluan" @click="hantarresetkatalaluan">
                    {{ $t("hantar") }}
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import i18n from "@/i18n";
import axios from "../../plugins/axios";
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage();
export default {
  name: "Penggunasistem",
  setup() {},
  data: () => ({
    disableperananadmin:false,
    disablenegeri: false,
    snackbar: "",
    perananpilihan: [],
    dialogtambahpengguna: false,
    dialogkemaskinipengguna: false,
    // Reset kata laluan pengguna (SUPERADMIN sahaja)
    MIN_PANJANG_KATALALUAN: 8,
    dialogresetkatalaluan: false,
    resetidpengguna: "",
    resetnamapengguna: "",
    resetkatalaluanbaru: "",
    resetmasukkatalaluanbaru: "",
    paparresetbaru: false,
    paparresetsemulabaru: false,
    search: "",
    statussemakkemaskininama: false,
    statussemakkemaskiniemel: false,
    carinamapengguna: "",
    cariemelpengguna: "",
    cariperananpengguna: "",
    daftarnama: "",
    daftaremel: "",
    daftaperanan: "",
    daftarnegeri: "",
    idpengguna: "",
    semakkemaskininama: "",
    kemaskininama: "",
    required(text) {
      return (v) =>
        (v && v.length > 0) || `${i18n.t(text)} ${i18n.t("adalahdiperlukan")}`;
    },
    // Rule kekuatan kata laluan: panjang >= 8 + sekurang-kurangnya 3 daripada
    // 4 jenis karakter (huruf besar/kecil, nombor, simbol khas).
    kekuatankatalaluan(value) {
      const v = value || "";
      if (v.length < 8) {
        return `${i18n.t("minimum")} 8 aksara`;
      }
      const jenis = [/[A-Z]/, /[a-z]/, /[0-9]/, /[^A-Za-z0-9]/]
        .filter((re) => re.test(v)).length;
      return jenis >= 3 || "Perlu sekurang-kurangnya 3 daripada 4 jenis karakter";
    },
    katalaluanbarusama(a, b) {
      return a === b || `${i18n.t("katalaluanbaru")} ${i18n.t("tidakpadan")}`;
    },
    emelsudahwujud: () => true || this.msgkemaskiniemelsudahwujud,
    namamin6: () => true || this.msgnamamin6,
    rules: {
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || `${i18n.t("emeltidaklengkap")}`;
      },
    },
    msgnamamin6: "",
    msgkemaskiniemelsudahwujud: "",
    kemaskiniemel: "",
    semakkemaskiniemel: "",
    kemaskininegeri: "",
    kemaskiniperanan: "",
    kemaskinistatus:"",
    lookupnegeri: [],
    carilookupperanan: [],
    daftarlookupperanan: [],
    datapengguna: [],
    defaultHeaders: [
      {
        text: "Bil.",
        align: "start",
        sortable: false,
        value: "no",
      },
      { text: i18n.t("nama"), value: "nama" },
      { text: i18n.t("emel"), value: "emel" },
      { text: i18n.t("negeri"), value: "negeri" },
      { text: i18n.t("peranan"), value: "peranan" },
      // { text: i18n.t("statuslogmasuk"), value: "statuslogmasuk" },
      { text: i18n.t("statusakaun"), value: "statusakaun" },
    ],
  }),
  computed: {
    isSuperadmin() {
      const user = localStorageData.user();
      return !!user && user.role === "SUPERADMIN";
    },
    tableHeaders() {
      if (this.isSuperadmin) {
        return [
          ...this.defaultHeaders,
          { text: i18n.t("tindakan"), value: "tindakan", sortable: false, align: "center" },
        ];
      }
      return this.defaultHeaders;
    },
    petunjukPanjang() {
      return (this.resetkatalaluanbaru || "").length >= this.MIN_PANJANG_KATALALUAN;
    },
    petunjukHurufBesar() { return /[A-Z]/.test(this.resetkatalaluanbaru || ""); },
    petunjukHurufKecil() { return /[a-z]/.test(this.resetkatalaluanbaru || ""); },
    petunjukNombor() { return /[0-9]/.test(this.resetkatalaluanbaru || ""); },
    petunjukSimbol() { return /[^A-Za-z0-9]/.test(this.resetkatalaluanbaru || ""); },
    bilanganJenisKarakter() {
      return [this.petunjukHurufBesar, this.petunjukHurufKecil, this.petunjukNombor, this.petunjukSimbol]
        .filter(Boolean).length;
    },
    bolehResetKatalaluan() {
      return (
        this.petunjukPanjang &&
        this.bilanganJenisKarakter >= 3 &&
        this.resetkatalaluanbaru === this.resetmasukkatalaluanbaru
      );
    },
  },
  mounted() {
    this.semuadatapengguna();
    this.lookup();
  },
  methods: {
    async tukarnegerikeadmin(){
      if(this.daftaperanan === "ADMIN" || this.daftaperanan === "SUPERADMIN"){
         this.daftarnegeri = '20'
      }
    },
    async lookup() {
      this.userData = localStorageData.user()
      console.log(this.userData)
      console.log(this.userData.role)
      if(!['ADMIN', 'SUPERADMIN'].includes(this.userData.role)){
        this.daftarnegeri = this.userData.kodneg
        this.disablenegeri = true
        this.disableperananadmin = true
      }
      await axios
        .get(`${process.env.VUE_APP_API_URL}/penggunasistem/lookup`)
        .then((response) => {
          this.lookupnegeri = response.data.lookupnegeri;
          this.carilookupperanan = response.data.carilookupperanan;
          this.daftarlookupperanan = response.data.daftarlookupperanan;
        })
        .catch((error) => {
          console.log(error);
          alert(error);
        });
    },
    async caridatapengguna() {
      // this.cariemelpengguna
      // this.search
      // alert(`${this.cariemelpengguna} ${this.search}`)
      this.semuadatapengguna();
    },
    async modaltambahpengguna() {
      this.dialogtambahpengguna = true;
      // this.$refs.formtambahpengguna.resetValidation();
    },
    async hantartambahpengguna() {
      if (this.$refs.formtambahpengguna.validate()) {
        const daftarpengguna = {
          daftarnama: this.daftarnama,
          daftaremel: this.daftaremel,
          daftaperanan: this.daftaperanan,
          daftarnegeri: this.daftarnegeri,
        };
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/penggunasistem/daftarpengguna`,
            daftarpengguna
          )
          .then((response) => {
            if (response.data.status) {
              this.$refs.formtambahpengguna.reset();
              this.$refs.formtambahpengguna.resetValidation();
              this.snackbar = {
                message: i18n.t("berjaya"),
                timeout: 2000,
                color: "success",
                show: true,
              };
            }
          })
          .catch((error) => {
            console.log(error);
            alert(error);
          });

        // this.semuadatapengguna()
      }
    },
    async semuadatapengguna() {
      let tapisandatapengguna = {
        //negeri: "01",
        negeri: this.daftarnegeri,
        name: this.carinamapengguna,
        emel: this.cariemelpengguna,
        peranan: this.cariperananpengguna,
      };
      await axios
        .get(`${process.env.VUE_APP_API_URL}/penggunasistem/paparpengguna`, {
          params: tapisandatapengguna,
        })
        .then((response) => {
          this.datapengguna = response.data.data;
          // console.log(res.data.data)
          // let list=[];
          // res.data.data.map(function(pengguna) {
          //     list.push(pengguna.name);e
          // });
          // console.log(res.data.data)eee
          // this.datapengguna = res.data.data
        })
        .catch((error) => {
          console.log(error);
          alert(error);
        });
    },
    async modalkemaskinidatapengguna(row) {
      await axios
        .post(
          `${process.env.VUE_APP_API_URL}/penggunasistem/paparmaklumatpengguna`,
          { idpengguna: row.id }
        )
        .then((response) => {
          console.log(response.data.data)
          this.idpengguna = response.data.data.id;
          this.semakkemaskininama = response.data.data.name;
          this.kemaskininama = response.data.data.name;
          this.kemaskiniemel = response.data.data.email;
          this.semakkemaskiniemel = response.data.data.email;
          this.kemaskininegeri = response.data.data.state;
          this.kemaskiniperanan = response.data.data.role;
          this.perananpilihan = response.data.maklumatperanan;
          this.dialogkemaskinipengguna = true;
          this.emelsudahwujud = true;
          this.kemaskinistatus = response.data.data.accountStatus;
          this.msgkemaskiniemelsudahwujud = "";
        })
        .catch((error) => {
          console.log(error);
          alert(error);
        });
    },
    modalresetkatalaluan(item) {
      this.resetidpengguna = item.id;
      this.resetnamapengguna = item.nama;
      this.resetkatalaluanbaru = "";
      this.resetmasukkatalaluanbaru = "";
      this.paparresetbaru = false;
      this.paparresetsemulabaru = false;
      this.dialogresetkatalaluan = true;
      if (this.$refs.formresetkatalaluan) {
        this.$refs.formresetkatalaluan.resetValidation();
      }
    },
    async hantarresetkatalaluan() {
      if (!this.$refs.formresetkatalaluan.validate()) {
        return;
      }
      const datareset = {
        idpengguna: this.resetidpengguna,
        katalaluanbaru: this.resetkatalaluanbaru,
        masukkatalaluanbaru: this.resetmasukkatalaluanbaru,
      };
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}/penggunasistem/tetapkansemulakatalaluanpengguna`,
          datareset
        );
        if (response.data.status) {
          this.snackbar = {
            message: i18n.t("berjaya"),
            timeout: 2000,
            color: "success",
            show: true,
          };
          this.dialogresetkatalaluan = false;
        } else {
          this.snackbar = {
            message: response.data.message || i18n.t("gagal"),
            timeout: 3000,
            color: "red darken-4",
            show: true,
          };
        }
      } catch (error) {
        console.log(error);
        alert(error);
      }
    },
    async hantarkemaskinipengguna() {
      if (this.$refs.formkemaskinimaklumatpengguna.validate()) {
        if (this.semakkemaskiniemel === this.kemaskiniemel) {
          this.statussemakkemaskiniemel = true;
        }
        const kemaskinidatapengguna = {
          emelsudahwujud: this.statussemakkemaskiniemel,
          idpengguna: this.idpengguna,
          kemaskininama: this.kemaskininama,
          kemaskiniemel: this.kemaskiniemel,
          kemaskininegeri: this.kemaskininegeri,
          kemaskiniperanan: this.perananpilihan,
          kemaskinistatus: this.kemaskinistatus
        };
        await axios
          .post(
            `${process.env.VUE_APP_API_URL}/penggunasistem/kemaskinimaklumatpengguna`,
            kemaskinidatapengguna
          )
          .then((response) => {
            console.log(response.data.status);
            this.semuadatapengguna();
            if (!response.data.status) {
              if (response.data.msg === "emel sudah wujud") {
                this.msgkemaskiniemelsudahwujud = i18n.t("emelsudahwujud");
                this.emelsudahwujud = false;
              } else {
                this.snackbar = {
                  message: i18n.t("gagal"),
                  timeout: 2000,
                  color: "red darken-4",
                  show: true,
                };
              }
              return;
            }
            this.snackbar = {
              message: i18n.t("berjaya"),
              timeout: 2000,
              color: "success",
              show: true,
            };
            this.dialogkemaskinipengguna = false;
          })
          .catch((error) => {
            console.log(error);
            alert(error);
          });
      }
    },
    warnastatuslogmasuk(status) {
      if (status === "Login") {
        return "green--text";
      } else {
        return "red--text";
      }
    },
    statusakaun(status) {
      if (status === "Enable") {
        return "green--text";
      } else {
        return "red--text";
      }
    },
  },
  watch: {
    async daftaremel(val) {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (pattern.test(val)) {
        const keputusansemakemel = await axios.post(
          `${process.env.VUE_APP_API_URL}/penggunasistem/semakemel`,
          { semakemel: val }
        );
        if (!keputusansemakemel.data.status) {
          this.msgkemaskiniemelsudahwujud = i18n.t("emelsudahwujud");
          this.emelsudahwujud = false;
        } else {
          this.msgkemaskiniemelsudahwujud = "";
          this.emelsudahwujud = true;
        }
      }
    },
    async daftarnama(val) {
      if (val.length < 4) {
        this.msgnamamin6 = `${i18n.t("minimum")} 4`;
        this.namamin6 = false;
      } else {
        this.msgnamamin6 = ``;
        this.namamin6 = true;
      }
    },
  },
};
</script>